import React from "react";

export interface FooterProps {
  children: any;
}

const Footer = React.memo((props: FooterProps) => <div className="modal-footer">{props.children}</div>);
export default Footer;
